module.exports = __webpack_public_path__ + "static/img/アセット 11@2x.5c4accc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/other/アセット 11@2x.png
// module id = ZuV5
// module chunks = 1